import { Component, OnInit, Input, Output, EventEmitter, ElementRef, QueryList, ViewChild, ContentChildren, AfterViewInit, ChangeDetectorRef, OnDestroy } from '@angular/core';

import { DialogService } from 'primeng/dynamicdialog';

import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';

import { ConfirmDismissDialogComponent } from 'app/modules/shared/components/confirm-dismiss-dialog/confirm-dismiss-dialog.component';
import { AppTemplateDirective } from 'app/directive/template.directive';
import { HelperService } from 'app/services';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-accordian',
  templateUrl: './accordian.component.html',
  styleUrls: ['./accordian.component.scss'],
})
export class AccordianComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() id: string = '';
  @Input() data: any;
  @Input() dataIdKey: string = '_id';
  @Input() headerLabel: string;
  @Input() headerCountLabel: string;
  @Input() listItemKey: string;
  @Input() listItemLabel: string;
  @Input() itemCheckboxPositiion: string = 'end';
  @Input() headerCheckboxPosition: string = 'end';
  @Input() confirmationTitle: string = '';
  @Input() confirmationContent: string = '';
  @Input() showSelectedItem: boolean = false;
  @Input() showConfirmDeselectModal: boolean = false;
  @Input() isMotorServiceEnhanced: boolean = false;
  @Input() fontSize: number = 12;
  @Input() iconSize: number = 12;
  @Input() index: number;
  @Input() listItemIdKey: string;
  @Input() renderSelectItemText: Function;
  @Input() showType: boolean = true;
  @Input() hasQuantityChanged: any;
  @Input() isDragable: boolean = false;

  @Input() hasCustomSelectedItemText: boolean = false;
  @Input() hasItemCheckbox: boolean = false;
  @Input() hasHeaderCheckbox: boolean = false;
  @Input() hasCustomTemplate: boolean = false;
  @Input() hasCustomHeader: boolean = false;
  @Input() hasDeleteOption: boolean = false;
  @Input() hasAccordianSubItem: boolean = false;
  @Input() hasAccordianSubItemCheckbox: boolean = true;
  @Input() hasAccordianSubItemInspection: boolean = false;
  @Input() customHeaderTransparentBg: boolean = false;
  @Input() inspectionChecked = false;
  @Input() disableInspectionCheckbox = false;
  @Input() hasItemSubItem: boolean = false;
  checkboxIcon: string = 'fal fa-check';
  @Input() hasLaborSelected = false;

  @Output() handleHeaderCheckChange = new EventEmitter<any>();
  @Output() handleItemSelectChange = new EventEmitter<any>();
  @Output() handleInspectionItemSelectChange = new EventEmitter<any>();
  @Output() handleDelete = new EventEmitter<any>();
  @Output() handleReset = new EventEmitter<any>();
  @Output() appOnExpand = new EventEmitter<any>();
  @Output() dragDisabled = new EventEmitter<any>();

  @ViewChild('accordianHeaderTemplate', { static: true })
  accordianHeaderTemplate: ElementRef;
  @ViewChild('accordianFooterTemplate', { static: true })
  accordianFooterTemplate: ElementRef;
  @ViewChild('accordianItemTemplete', { static: true })
  accordianItemTemplate: ElementRef;
  @ViewChild('accordianSubItemTemplete', { static: true })
  accordianSubItemTemplate: ElementRef;
  @ViewChild('accordianSubItemInspectionsTemplate', { static: true })
  accordianSubItemInspectionsTemplate: ElementRef;

  @ContentChildren(AppTemplateDirective) templates: QueryList<any>;

  isExpanded: boolean = false;
  items: any[] = [];
  selectedItems: any[] = [];
  selectedCount: number = 0;
  disableDragging = true;
  subscriptions: Subscription[] = [];

  constructor(private cdr: ChangeDetectorRef, private dialogService: DialogService, private helperService: HelperService) { }
  
  ngOnInit() {
    this.populatingList();
    this.subscriptions.push(
      this.helperService.confirmationSubject.subscribe(data => {
        if (!data.status) {
          this.unCheck(data)
        }
      })
    )
  }

  ngAfterViewInit() {
    this.getCustomTemplate();
    this.cdr.detectChanges();
  }

  drop(event: CdkDragDrop<string[]>) {
    this.disableDragging = true;
    if (event.previousContainer.id === event.container.id) {
      if (event.currentIndex !== this.items.length - 1) {
        moveItemInArray(this.items, event.previousIndex, event.currentIndex);
        // this.updateService();
      } else if (event.currentIndex === this.items.length - 1) {
        moveItemInArray(this.items, event.previousIndex, event.currentIndex - 1);
        // this.updateService();
      }
    }
  }

  /** toggle accordian */
  toggleIsExpanded() {
    this.isExpanded = !this.isExpanded;
    this.appOnExpand.emit({
      isExpanded: this.isExpanded,
    });
  }

  dragItem() {
    this.dragDisabled.emit();
  }

  /** populate first level list */
  populatingList() {
    if (this.data) {
      const list: any[] = this.data[this.listItemKey];
      if (list && list.length) {
        this.items = list;
      }
    }
    this.selectedItems = this.items.filter((item) => item.isChecked);
  }

  /** render header from the object with the given key */
  renderHeaderTitle() {
    return this.data[this.headerLabel];
  }

  /** render first level list count */
  renderListItemCount() {
    const list: any[] = this.data[this.listItemKey];
    if (list) {
      return list.length;
    }
    return 0;
  }

  /** render title of first level list items */
  renderFirstLevelItemTitle(item) {
    const title = item && item[this.listItemLabel];
    return title ? title : '';
  }

  /** render selected item */
  renderSelectedItemLabel() {
    if (this.renderSelectItemText) {
      return this.renderSelectItemText({
        totalCount: this.items.length,
        selectedCount: this.selectedItems.length,
      });
    }

    return '';
  }

  /** handle check and uncheck dropdown */
  handleCheckItem(isChecked: boolean, item: any, index?: number, showConfirmationModal: boolean = true) {
    if (item.type === 'bundle') {
      if (item.subItems && item.subItems.length) {
        item.subItems.forEach((subItem: any) => {
          subItem.isChecked = isChecked;
        });
      }
      item.checkboxIcon = 'fal fa-check';
    }
    if (isChecked) {
      this.selectedItems.push(item);
      this.handleItemSelectChange.emit({
        isChecked,
        data: item,
        list: [...this.selectedItems],
        index,
        id: this.data[this.dataIdKey],
      });
    } else {
      let selectedItemIndex = -1;
      for (let i = 0; i < this.selectedItems.length; i++) {
        if (this.selectedItems[i][this.listItemIdKey] === item[this.listItemIdKey]) {
          selectedItemIndex = i;
        }
      }

      if (this.selectedItems.length === 1 && this.showConfirmDeselectModal && showConfirmationModal && this.hasQuantityChanged(this.data)) {
        this.openConfirmationModal(isChecked, item, index);
        return;
      }

      if (selectedItemIndex > -1) {
        this.selectedItems.splice(selectedItemIndex, 1);
      }
      this.handleItemSelectChange.emit({
        isChecked,
        data: item,
        list: [...this.selectedItems],
        index,
        id: this.data[this.dataIdKey],
      });
    }
  }

  openConfirmationModal(isChecked: boolean, item: any, index: number) {
    const ref = this.dialogService.open(ConfirmDismissDialogComponent, {
      width: '35%',
      styleClass: 'small-heading-dialog',
      showHeader: false,
      data: {
        title: this.confirmationTitle,
        message: this.confirmationContent,
        button: {
          success: { title: 'Confirm' },
          cancel: { title: 'Cancel' },
        },
      },
    });

    const onClose = ref.onClose.subscribe(({ isSuccess, data }) => {
      if (isSuccess) {
        this.handleCheckItem(isChecked, item, index, false);
        this.handleReset.emit({ service: this.data, index });
      } else {
        const ids = this.selectedItems.map((item) => item[this.listItemIdKey]);

        this.items.forEach((item) => {
          if (ids.indexOf(item[this.listItemIdKey]) !== -1) {
            item.isChecked = true;
          }
        });
      }

      onClose.unsubscribe();
    });
  }

  handleHeaderCheckItem = (type: string, event: any, openOnSelect = true, isMotorService = false) => {
    event.stopPropagation();

    if (isMotorService && type === 'select') {
      this.selectedItems = type === 'select' ? [...this.items.filter((item) => this.hasLaborSelected && item.type === 'labor'
        || !this.hasLaborSelected && item.type !== 'parts')] : [];

      this.items.forEach((item) => {
        if (this.hasLaborSelected && item.type === 'labor'
          || !this.hasLaborSelected && item.type !== 'parts'
        ) {

          item.isChecked = type === 'select';
          if (item.type === 'bundle' && item.subItems && item.subItems.length) {
            item.subItems.forEach((subItem: any) => {
              subItem.isChecked = type === 'select';
            });
            item.checkboxIcon = 'fal fa-check';
          }
        }
      });
    } else {
      this.selectedItems = type === 'select' ? [...this.items] : [];
      this.items.forEach((item) => {
        item.isChecked = type === 'select';
        if (item.type === 'bundle' && item.subItems && item.subItems.length) {
          item.subItems.forEach((subItem: any) => {
            subItem.isChecked = type === 'select';
          });
          item.checkboxIcon = 'fal fa-check';
        }
      });
    }
    this.handleHeaderCheckChange.emit({
      id: this.data[this.dataIdKey],
      list: [...this.selectedItems],
      index: this.index,
    });
    if (openOnSelect) {
      this.isExpanded = type === 'select';

      this.appOnExpand.emit({
        isExpanded: this.isExpanded,
      });
    }
  };

  handleInspectionCheckItem(event) {
    this.handleInspectionItemSelectChange.emit({
      inspectionChecked: this.inspectionChecked,
      index: this.index,
      id: this.data._id,
    });
  }

  handleGroupDelete() {
    this.handleDelete.emit({ index: this.index, data: this.data });
  }

  toggleAccordian = (isExpanded: boolean) => {
    this.isExpanded = isExpanded;
    this.appOnExpand.emit({
      isExpanded: this.isExpanded,
    });
  };

  getCustomTemplate() {
    this.templates.forEach((item) => {
      switch (item.getType()) {
        case 'accordian-header':
          this.accordianHeaderTemplate = item.template;
          break;

        case 'accordian-item':
          this.accordianItemTemplate = item.template;
          break;

        case 'accordian-sub-item':
          this.accordianSubItemTemplate = item.template;
          break;

        case 'accordian-footer':
          this.accordianFooterTemplate = item.template;
          break;

        case 'accordian-sub-item-inspections':
          this.accordianSubItemInspectionsTemplate = item.template;
          break;
      }
    });
  }

  unCheck(itemStatus) {
    this.items.forEach(item => {
      if (item._id === itemStatus.id) {
        item.isChecked = itemStatus.status
      }
    })
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(listener => listener.unsubscribe())
  }
}
